import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";
const mapToOptions = (data, labelKey = 'name', valueKey = 'code') => {
  console.log("data",data);
  
    return data.map(item => ({ label: item[labelKey], value: item[valueKey] }));
};
export const getCoursesFromServer = async (page = 1,pageSize = 10) => {
  try {
    const response = await axiosInstance.get(`courses?page=${page}&limit=${pageSize}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
     if(response && response.data && response.data.encryptedData){
          const decryptedData = TokenDecrypt(response.data.encryptedData);
          return decryptedData;
        }
          return [];
  } catch (error) {
    console.error("Error fetching courses:", error); 
    throw new Error("Failed to fetch courses");
  }
};

export const getCourseCategory = async () => {
    try {
      const response = await axiosInstance.get("categories/list", {
        headers: {
          "Content-Type": "application/json",
        },
      }); 
       if (response?.data?.encryptedData) {
            const decryptedData = TokenDecrypt(response.data.encryptedData);
            if (decryptedData?.data) {
              console.log("decryptedData?.data",decryptedData?.data);
              
              return mapToOptions(decryptedData.data, "title", "id");
            }
          }
          return [];
    } catch (error) {
      console.error("Error fetching Course Category:", error);
      throw new Error("Failed to fetch Course Category");
    }
  };

  export const addCourse = async (courseData) => {
    try {
      const jsonData = Object.fromEntries(courseData.entries());
      const response = await axiosInstance.post("courses", jsonData, {
        headers: {
            "Content-Type": "application/json",
        },
      });
      return response
    } catch (error) {
      console.error("Error adding Course:", error);
      throw new Error("Failed add Course");
    }
  };

  export const updateCourse = async (courseId, courseData) => {
    try {
      const jsonData = Object.fromEntries(courseData.entries());
      
      const response = await axiosInstance.put(`courses/${courseId}`, jsonData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      console.error("Error updating Course:", error);
      throw new Error("Failed to update Course");
    }
  };
  
  export const getPublishCourse = async (id) => {
    try {
      const response = await axiosInstance.get(`courses/publish/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response
    } catch (error) {
      console.error("Error Publishing Course :", error);
      throw new Error("Failed to Publish Course");
    }
  };

  export const getRole = async () => {
    try {
      const response = await axiosInstance.get("roles/list", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.encryptedData) {
            const decryptedData = TokenDecrypt(response.data.encryptedData);
            if (decryptedData?.data) {
              console.log("decryptedData?.data",decryptedData?.data);
              
              return mapToOptions(decryptedData.data, 'rolename', 'roleid');
            }
          }
          return [];
    } catch (error) {
      console.error("Error fetching Role:", error);
      throw new Error("Failed to fetch Role");
    }
  };

  export const deleteCourse = async (id) => {
  try {
    const response = await axiosInstance.delete(`/courses/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to delete course.";
    console.error("Error in deleteCourse:", errorMessage);
    throw new Error(errorMessage);
  }
};